import Form     from 'scripts/poppet/form';
import template from 'templates/unitNotesForm.jst.html';

const selectors = {
	inputNotes: '[data-input=unit-notes]',
};

/**
 * defa.views.UnitNotesForm
 * A view for changing a units alias.
 * @version 1.0.0
 */
const UnitNotesForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	ui: {
		notes: selectors.inputNotes,
	},

	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	validate: function(){
		let inputNotes = this.ui.notes.val().trim();
		let previousNotes = this.model.get('notes');
	return 	inputNotes !== previousNotes;
	},
	/**
	 * Submits the form.
	 * @void
	 */
	submit: function () {
		let notes = this.ui.notes.val().trim();
		this.model.saveNotes( {
			notes: notes,
		} );
	},
	
} );


export default UnitNotesForm;